// MOB M1-0: API ve panel kök adresi tek kaynaktan — Servis.js ile aynı kural (NODE_ENV).
// Eskiden bazı yardımcılar `window.location.hostname === 'localhost'` ile karar veriyordu; Capacitor
// Android uygulamayı https://localhost'tan sunduğu için mobilde geliştirici API'sine gidiyordu.
const uretim = process.env.NODE_ENV === "production";

export const API_KOK = uretim ? "https://api.hepy.app/api/" : "https://localhost:44386/api/";

// Dışarıya verilen panel bağlantıları (gömme kodu vb.). Geliştirmede bulunduğun adres.
export const PANEL_KOK = uretim ? "https://panel.hepy.app" : window.location.origin;
